/**
 * ⚠️ AUTO-GENERATED FILE - DO NOT EDIT
 *
 * Generated by: sf database-code
 * Generated from database schema
 *
 * To modify: Change the database schema and re-run `sf database-code` (dc)
 */
/* eslint-disable complexity */
import { isObject, hasPropOfType, UUID, Temporal, type LocalDatabaseTableDefinition } from 'sf-shared';
import type { MealBase } from 'shared/dbo/Meal';

export interface MealIndexedDb {
	id: string;
	mealTitle: string;
	rangeStartTime: string;
	rangeEndTime: string;
	validSunday: boolean;
	validMonday: boolean;
	validTuesday: boolean;
	validWednesday: boolean;
	validThursday: boolean;
	validFriday: boolean;
	validSaturday: boolean;
	created: number;
	lastModified: number;
	shortId: string;
}

const isMealIndexedDb1 = (
	obj: unknown
): obj is {
	id: string;
	mealTitle: string;
	rangeStartTime: string;
	rangeEndTime: string;
	validSunday: boolean;
	validMonday: boolean;
	validTuesday: boolean;
	validWednesday: boolean;
	validThursday: boolean;
	validFriday: boolean;
} => {
	if (!isObject(obj)) {
		return false;
	}
	if (!hasPropOfType<{ id: unknown }>(obj, 'id') || !(typeof obj.id === 'string')) {
		return false;
	}
	if (!hasPropOfType<{ mealTitle: unknown }>(obj, 'mealTitle') || !(typeof obj.mealTitle === 'string')) {
		return false;
	}
	if (!hasPropOfType<{ rangeStartTime: unknown }>(obj, 'rangeStartTime') || !(typeof obj.rangeStartTime === 'string')) {
		return false;
	}
	if (!hasPropOfType<{ rangeEndTime: unknown }>(obj, 'rangeEndTime') || !(typeof obj.rangeEndTime === 'string')) {
		return false;
	}
	if (!hasPropOfType<{ validSunday: unknown }>(obj, 'validSunday') || !(typeof obj.validSunday === 'boolean')) {
		return false;
	}
	if (!hasPropOfType<{ validMonday: unknown }>(obj, 'validMonday') || !(typeof obj.validMonday === 'boolean')) {
		return false;
	}
	if (!hasPropOfType<{ validTuesday: unknown }>(obj, 'validTuesday') || !(typeof obj.validTuesday === 'boolean')) {
		return false;
	}
	if (!hasPropOfType<{ validWednesday: unknown }>(obj, 'validWednesday') || !(typeof obj.validWednesday === 'boolean')) {
		return false;
	}
	if (!hasPropOfType<{ validThursday: unknown }>(obj, 'validThursday') || !(typeof obj.validThursday === 'boolean')) {
		return false;
	}
	if (!hasPropOfType<{ validFriday: unknown }>(obj, 'validFriday') || !(typeof obj.validFriday === 'boolean')) {
		return false;
	}
	return true;
};

const isMealIndexedDb2 = (
	obj: unknown
): obj is {
	validSaturday: boolean;
	created: number;
	lastModified: number;
	shortId: string;
} => {
	if (!isObject(obj)) {
		return false;
	}
	if (!hasPropOfType<{ validSaturday: unknown }>(obj, 'validSaturday') || !(typeof obj.validSaturday === 'boolean')) {
		return false;
	}
	if (!hasPropOfType<{ created: unknown }>(obj, 'created') || !(typeof obj.created === 'number')) {
		return false;
	}
	if (!hasPropOfType<{ lastModified: unknown }>(obj, 'lastModified') || !(typeof obj.lastModified === 'number')) {
		return false;
	}
	if (!hasPropOfType<{ shortId: unknown }>(obj, 'shortId') || !(typeof obj.shortId === 'string')) {
		return false;
	}
	return true;
};

export const isMealIndexedDb = (obj: unknown): obj is MealIndexedDb => {
	if (!isObject(obj)) {
		return false;
	}
	if (!isMealIndexedDb1(obj)) {
		return false;
	}
	if (!isMealIndexedDb2(obj)) {
		return false;
	}
	return true;
};

export const baseToIndexedDB = (obj: MealBase): MealIndexedDb => ({
	id: obj.id.toString(),
	mealTitle: obj.mealTitle,
	rangeStartTime: obj.rangeStartTime.toString(),
	rangeEndTime: obj.rangeEndTime.toString(),
	validSunday: obj.validSunday,
	validMonday: obj.validMonday,
	validTuesday: obj.validTuesday,
	validWednesday: obj.validWednesday,
	validThursday: obj.validThursday,
	validFriday: obj.validFriday,
	validSaturday: obj.validSaturday,
	created: obj.created.epochMilliseconds,
	lastModified: obj.lastModified.epochMilliseconds,
	shortId: obj.id.shortString,
});

export const indexedDBToBase = (obj: MealIndexedDb): MealBase => ({
	id: UUID.fromString(obj.id),
	mealTitle: obj.mealTitle,
	rangeStartTime: Temporal.PlainTime.from(obj.rangeStartTime),
	rangeEndTime: Temporal.PlainTime.from(obj.rangeEndTime),
	validSunday: obj.validSunday,
	validMonday: obj.validMonday,
	validTuesday: obj.validTuesday,
	validWednesday: obj.validWednesday,
	validThursday: obj.validThursday,
	validFriday: obj.validFriday,
	validSaturday: obj.validSaturday,
	created: Temporal.Instant.fromEpochMilliseconds(obj.created),
	lastModified: Temporal.Instant.fromEpochMilliseconds(obj.lastModified),
	objectContext: 'db',
});

export const itdMeal: LocalDatabaseTableDefinition<MealBase, MealIndexedDb> = {
	tableName: 'meals',
	indexColumns: [],
	convertToIndexed: baseToIndexedDB,
	convertFromIndexed: indexedDBToBase,
};
